import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Link } from "react-router-dom";
import img1 from "../assets/images/logo colegio (32).png";

function NavigationNavHome() {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  const handleToggleMenu = () => setShowMenu(!showMenu);
  const handleCloseMenu = () => setShowMenu(false);

  return (
    <>
      <nav
        className="navbar sticky-top px-3"
        style={{ background: "rgb(61, 102, 81)" }}
      >
        <div className="container-fluid d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <img
              src={img1}
              alt="Logo Colegio"
              className="logo-animado"
              style={{ height: "60px", width: "auto" }}
            />
            <div className="ms-3 text-home">
              <h1 className="mb-0 mt-2 fs-1" id="texto-nav-homecolegio">
                Colegio Santo Tomás
              </h1>
              <p className="mb-0 text-center" id="texto-nav-home">
                Nivel Inicial - Primario - Secundario
              </p>
            </div>
          </div>

          <div className="d-flex gap-2">
            <button
              className="btn text-light border-1 btn nav-small-btn d-none d-md-inline"
              style={{ background: "none" }}
              onClick={() => navigate("/.  ")}
            >
              HOME
            </button>
            <button
              className="btn text-light border-1 btn nav-small-btn d-none d-md-inline"
              style={{ background: "none" }}
              onClick={() => navigate("/TrabajaConNosotros")}
            >
              TRABAJÁ CON NOSOTROS
            </button>

            <div className="dropdown d-none d-md-inline">
              <button
                className="btn dropdown-toggle nav-portal-login-btn"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Log in
              </button>

              <ul className="dropdown-menu dropdown-menu-end shadow nav-portal-login-menu">
                <li>
                  <button
                    className="dropdown-item nav-portal-login-item d-flex align-items-center gap-3 py-3"
                    onClick={() => navigate("/login")}
                  >
                    <span className="nav-portal-login-icon nav-portal-login-icon-familias">
                      F
                    </span>
                    <div>
                      <div className="nav-portal-login-title">Acceso Familias</div>
                      <small className="nav-portal-login-subtitle">
                        Padres y tutores
                      </small>
                    </div>
                  </button>
                </li>

                <li>
                  <hr className="dropdown-divider nav-portal-login-divider" />
                </li>

                <li>
                  <button
                    className="dropdown-item nav-portal-login-item d-flex align-items-center gap-3 py-3"
                    onClick={() => navigate("/loginEmpleados")}
                  >
                    <span className="nav-portal-login-icon nav-portal-login-icon-empleados">
                      E
                    </span>
                    <div>
                      <div className="nav-portal-login-title">Acceso Empleados</div>
                      <small className="nav-portal-login-subtitle">
                        Docentes y personal
                      </small>
                    </div>
                  </button>
                </li>
              </ul>
            </div>

            <button
              className="btn fw-bold px-3 py-1 border-0 d-flex align-items-center gap-2"
              style={{
                background: "white",
                color: "rgb(41, 66, 53)",
                borderRadius: "20px",
                border: "2px solid rgb(0, 102, 49)",
                zIndex: 1000,
              }}
              onClick={handleToggleMenu}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M1.5 12a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1h-13zm0-4.5a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1h-13zM1.5 3a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1h-13z"
                />
              </svg>
              MENU
            </button>
          </div>
        </div>
      </nav>

      <div className={`menu-overlay text-white ${showMenu ? "show" : "hide"}`}>
        <div className="d-flex justify-content-end p-4">
          <button
            className="btn btn-light menu-close-btn border-0 gap-2"
            onClick={handleCloseMenu}
            style={{ borderRadius: "20px" }}
          >
            <strong>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M1.5 12a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1h-13zm0-4.5a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1h-13zM1.5 3a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1h-13z"
                />
              </svg>{" "}
              MENU
            </strong>
          </button>
        </div>
        <div className="container text-start px-5 pb-5">
          <div className="row row-cols-1 row-cols-md-3 g-4">
            <div className="menu-item ">
              <h5 className="text- white">
                <Link to="/" onClick={handleCloseMenu}>
                  Inicio
                </Link>
              </h5>
              <ul>
                <li><Link to="/login" onClick={handleCloseMenu}>Login</Link></li>
                <li><Link to="/home" onClick={handleCloseMenu}>Home</Link></li>
                <li>
                  <Link to="/TrabajaConNosotros" onClick={handleCloseMenu}>
                    Trabaja con nosotros
                  </Link>
                </li>
              </ul>
            </div>
            <div className="menu-item ">
              <h5 className="text- white">
                <Link to="/acerca" onClick={handleCloseMenu}>Acerca</Link>
              </h5>
              <ul>
                <li><Link to="/acerca#historia" onClick={handleCloseMenu}>Historia</Link></li>
                <li><Link to="/acerca#mision" onClick={handleCloseMenu}>Misión</Link></li>
                <li><Link to="/acerca#simbolos" onClick={handleCloseMenu}>Símbolos</Link></li>
                <li><Link to="/acerca#sedes" onClick={handleCloseMenu}>Sedes</Link></li>
                <li><Link to="/acerca#horarios" onClick={handleCloseMenu}>Horarios</Link></li>
              </ul>
            </div>
            <div className="menu-item">
              <h5 className="text-uppercase">
                <Link to="/proyectoEducativo " onClick={handleCloseMenu}>
                  Proyecto Educativo
                </Link>
              </h5>
              <ul>
                <li><Link to="/homeinicial" onClick={handleCloseMenu}>Nivel Inicial</Link></li>
                <li><Link to="/nivelprimario" onClick={handleCloseMenu}>Nivel Primario</Link></li>
                <li><Link to="/nivelsecundario" onClick={handleCloseMenu}>Nivel Secundario</Link></li>
                <li><Link to="/InglesIntensivo " onClick={handleCloseMenu}>Inglés Intensivo</Link></li>
              </ul>
            </div>
            <div className="menu-item">
              <h5 className="text-uppercase">
                <Link to="/Actividades" onClick={handleCloseMenu}>Actividades</Link>
              </h5>
              <ul>
                <li><Link to="/deportes" onClick={handleCloseMenu}>Educación Física</Link></li>
                <li><Link to="/arteActividad" onClick={handleCloseMenu}>Arte</Link></li>
                <li><Link to="/Actividades" onClick={handleCloseMenu}>Comunidad Activa</Link></li>
                <li><Link to="/catequesis" onClick={handleCloseMenu}>Catequesis</Link></li>
              </ul>
            </div>
            <div className="menu-item">
              <h5 className="text-uppercase">
                <Link to="/casas" onClick={handleCloseMenu}>Nuestras Casas</Link>
              </h5>
              <ul>
                <li><Link to="/equipos" onClick={handleCloseMenu}>Equipos </Link></li>
                <li>
                  <a
                    href="./planillas/nuevoUniforme.pdf"
                    download
                    onClick={handleCloseMenu}
                    className="nav-link"
                  >
                    Uniformes
                  </a>
                </li>
              </ul>
            </div>
            <div className="menu-item">
              <h5 className="text-uppercase">
                <Link to="/admision" onClick={handleCloseMenu}>Admisiones</Link>
              </h5>
              <ul>
                <li><Link to="/admision " onClick={handleCloseMenu}>Calendario</Link></li>
                <li><Link to="/admision " onClick={handleCloseMenu}>Proceso</Link></li>
                <li><Link to="/admision " onClick={handleCloseMenu}>Matriculación</Link></li>
              </ul>
            </div>
            <div className="menu-item">
              <h5 className="text-uppercase">
                <Link to="" onClick={handleCloseMenu}>Contacto</Link>
              </h5>
              <ul>
                <li><Link to="/contacto" onClick={handleCloseMenu}>Contacto</Link></li>
              </ul>
            </div>
            <div className="menu-item">
              <h5 className="text-uppercase">
                <Link to="/Login" onClick={handleCloseMenu}>Login</Link>
              </h5>
              <ul>
                <li><Link to="/Login " onClick={handleCloseMenu}>Acceso Familias</Link></li>
              </ul>
              <ul>
                <li><Link to="LoginEmpleados " onClick={handleCloseMenu}>Acceso Empleados</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="social-footer mt-5">
          <p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="currentColor"
              className="bi bi-geo-alt"
              viewBox="0 0 16 16"
            >
              <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
              <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
            </svg>{" "}
            La Pampa, Santa Rosa - Santiago del Estero 666
          </p>
          <div className="social-icons">
            <div className="btn-group">
              <a
                href="https://www.facebook.com/santotomasinstitucional"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-secondary"
              >
                <button type="button" className="btn btn-outline-secondary">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"></path>
                  </svg>
                  <span className="visually-hidden">Button</span>
                </button>
              </a>
              <a href=" https://www.instagram.com/colegiosantotomassantarosa/" target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary">
                <button type="button" className="btn btn-outline-secondary">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-instagram" viewBox="0 0 16 16">
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                  </svg>
                  <span className="visually-hidden">Button</span>
                </button>
              </a>
              <a href=" https://api.whatsapp.com/send/?phone=+542954313911&text=s" target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary">
                <button type="button" className="btn btn-outline-secondary">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 16 16">
                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                  </svg>
                  <span className="visually-hidden">Button</span>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NavigationNavHome;
